export const orgInfo = {
  ORG_NAME: "Notun Kuri English Version School",
};
